import React from 'react'
import styled, { css } from 'styled-components'
import SpinnerIcon from '../../../../../../../generic/icons/IconLib/SpinnerIcon'
import ShieldIcon from '../../../../../../../generic/icons/IconLib/ShieldIcon'
import ShieldOffIcon from '../../../../../../../generic/icons/IconLib/ShieldOffIcon'

type Variant = 'enable' | 'disable'

type Props = {
  variant: Variant
  onClick: () => void
  isLoading?: boolean
}

const TwoFactorButton = ({ variant, onClick, isLoading }: Props) => (
  <StyledButton
    $variant={variant}
    onClick={onClick}
    disabled={isLoading}
    aria-label={variant === 'enable' ? 'הפעל אימות דו-שלבי' : 'בטל אימות דו-שלבי'}
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        onClick()
      }
    }}
  >
    {isLoading ? (
      <Spinner><SpinnerIcon size={15} /></Spinner>
    ) : (
      <>
        {variant === 'enable' ? <ShieldIcon size={15} /> : <ShieldOffIcon size={15} />}
        <span>{variant === 'enable' ? 'הפעל' : 'בטל'}</span>
      </>
    )}
  </StyledButton>
)

const Spinner = styled.span`
  display: inline-flex;
  animation: spin 0.8s linear infinite;
  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
`

const enableStyle = css`
  background: #297f76;
  color: #fff;
  border: 2px solid #297f76;

  &:hover:not(:disabled) {
    background: #1e5e57;
    border-color: #1e5e57;
  }
`

const disableStyle = css`
  background: transparent;
  color: #297f76;
  border: 2px solid #297f76;

  &:hover:not(:disabled) {
    background: tomato;
    border-color: tomato;
    color: #fff;
  }
`

const StyledButton = styled.button<{ $variant: Variant }>`
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.55em 1.4em;
  border-radius: 20px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  ${({ $variant }) => ($variant === 'enable' ? enableStyle : disableStyle)}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export default TwoFactorButton
